module.exports = __webpack_public_path__ + "media/complexity-selector/complex@2x-6ec08e8b.png";